module.exports = __webpack_public_path__ + "static/media/header6.c439bb2a.png";